import { downloadFile, getFile, postFile } from '../utils/fetch';
import {
  MODE_ATTACHMENT_API_ERROR,
  MODE_ATTACHMENT_POST_API_ERROR,
} from '../defines/mode';

export const AttachmentApi = {
  getAttachment: async (fileId: string, fileName: string): Promise<string> => {
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.get('mode') === MODE_ATTACHMENT_API_ERROR) {
      throw new Error();
    }
    return (
      (await getFile(
        '/api/attachments',
        { fileId, fileName },
        'getAttachment',
      )) || ''
    );
  },

  downloadAttachment: async (
    fileId: string,
    fileName: string,
  ): Promise<void> => {
    const searchParams = new URLSearchParams(window.location.search);
    // it works dev-login only
    if (searchParams.get('mode') === MODE_ATTACHMENT_API_ERROR) {
      throw new Error();
    }
    await downloadFile(
      '/api/attachments',
      { fileId, fileName },
      'downloadAttachment',
      fileName,
    );
  },

  postAttachment: async (file: File): Promise<any> => {
    const searchParams = new URLSearchParams(window.location.search);
    // it works dev-login only
    if (searchParams.get('mode') === MODE_ATTACHMENT_POST_API_ERROR) {
      throw new Error();
    }
    return await postFile('/api/attachments', file);
  },
};
